<template>
  <div class="subtitle-view">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "SubTitleView",
})
</script>

<!-- Style -->
<style lang="scss" scoped>
@import "@/styles/variables.scss";

.subtitle-view {
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 34px;
  color: $title-default-color;
  text-align: left;
  line-height: 40px;
}
</style>
